export const indexCopy = {
  index_2_headline:
    "TypeScript é <bold>JavaScript com sintaxe para tipos.</bold>",
  index_2_byline: "O TypeScript estende o JavaScript adicionando tipos.",
  index_2_summary:
    "TypeScript é uma linguagem de programação fortemente tipada que se baseia em JavaScript, oferecendo melhores ferramentas em qualquer escala.",
  index_2_locations:
    "Qualquer navegador, Qualquer SO, em qualquer lugar onde JavaScript rodar. Completamente código aberto.",

  index_2_cta_play: "Tente no seu navegador",
  index_2_cta_install: "Instale localmente",

  index_2_what_is: "O que é TypeScript?",

  index_2_what_is_js: "JavaScript e Mais",
  index_2_what_is_js_copy: `O TypeScript adiciona sintaxe adicional ao JavaScript para oferecer suporte a uma <strong>integração mais estreita com seu editor</strong>. Detecte erros mais cedo em seu editor.`,

  index_2_trust: "Um Resultado Que Você Pode Confiar",
  index_2_trust_copy:
    "O código TypeScript é convertido em JavaScript, que <strong>funciona em qualquer lugar em que o JavaScript é executado</strong>: em um navegador, em Node.js ou Deno e em seus aplicativos.",
  index_2_trust_copy_a: `Todo código JavaScript válido é também um código TypeScript. Você pode obter erros de verificação de tipagem, mas isso não vai impedi-lo de executar o JavaScript resultante. Embora você possa optar por ser mais rígido, isso significa que você ainda está no controle.`,
  index_2_trust_copy_b: `Código TypeScript é transformado em código JavaScript através do compilador do TypeScript ou <babel>Babel</babel>. Esse JavaScript é um código limpo e simples que roda em qualquer lugar que o JavaScript possa ser executado: em um navegador, no Node.JS ou em seus aplicativos.`,

  index_2_scale: "Segurança em Escala",
  index_2_scale_copy:
    "O TypeScript entende JavaScript e usa <strong>inferência de tipos para fornecer ótimas ferramentas</strong> sem código adicional.",

  index_2_standards: "Evoluindo com Padrões",
  index_2_standards_copy: `
  <p>O time do TypeScript contribui para o comitê TC39 que ajudam a guiar a evolução do JavaScript.</p>

  <p>Quando as novas propostas atingem o estágio 3, eles estão prontos para inclusão no TypeScript.</p>
  
  <p>Por exemplo, a equipe do TypeScript defendeu propostas como Encadeamento opcional, Operador de coalescência nula, Throw Expressions e RegExp Match Indices.</p>`,

  index_2_gradual: "Adoção Gradual",
  index_2_gradual_copy: `
<p>Adotar TypeScript não é uma escolha binária, você pode começar anotando o JavaScript existente com JSDoc, e então trocar alguns arquivos para serem checados através do TypeScript e com o tempo preparar todo seu código para ser convertido completamente</p>

<p>A inferência de tipo do TypeScript significa que você não precisa fazer anotações em seu código até que queira mais segurança.</p>`,

  index_2_dts: "Tipagem Em Todos Os Lugares",
  index_2_dts_copy: `
<p>A maior parte do mundo do JavaScript não é tipada e a inferência só pode ir até certo ponto. Para resolver isso, a equipe do TypeScript ajuda a manter <dt> Definitely Typed </dt> - um projeto da comunidade para fornecer tipos e documentação para bibliotecas JavaScript existente.</p>

<p>Este projeto permite que a comunidade mantenha definições de tipo para bibliotecas JavaScript sem colocar pressão extra sobre seus mantenedores.</p>`,

  index_2_tools: "Ferramentas Consistentemente Boas",
  index_2_tools_copy: `
  <p>Ao lidar com grande parte da integração do editor dentro do TypeScript, você pode obter uma experiência consistente de trabalho em muitos editores.</p>

  <p>Isso permite que você alterne facilmente entre editores como <vs> Visual Studio </vs>, <vsc> Visual Studio Code </vsc>, <nova> Nova </nova>, <atom> Atom </atom>, <subl> Texto sublime </subl>, <emacs> Emacs </emacs>, <vim> Vim </vim>, <webs> WebStorm </webs> e <eclipse> Eclipse </eclipse>.</p>

  <p>A integração do editor do TypeScript suporta JavaScript, então é bem provável que você já esteja usando o TypeScript nos bastidores.
  `,

  index_2_started_title: "Iniciando",
  index_2_started_handbook: "Manual",
  index_2_started_handbook_blurb: "Aprenda a linguagem",
  index_2_playground_blurb: "Tente em seu navegador",
  index_2_started_docs: "Comece um Projeto",
  index_2_started_docs_blurb: "Encontre uma ferramenta de bootstrapping",
  index_2_started_tooling: "Ferramentas",
  index_2_started_tooling_blurb: "Aprofunde-se no TypeScript",
  index_2_started_community: "Comunidade",
  index_2_started_community_blurb: "Matenha-se atualizado",
  index_2_install: "Instale TypeScript",
  index_2_install_ref: `
  <p>Você pode instalar TypeScript através do npm<install>
  <p>E então rodar o compilador através do <code>tsc</code><pre>npx tsc</pre>
  <p>Aprenda mais como sobre adicionar TypeScript na suas aplicações na <download>página de instalação</download>
  `,
  index_2_adopt: "Adote o TypeScript Gradualmente",
  index_2_adopt_blurb_1:
    "Aplique tipos ao seu projeto JavaScript de forma incremental, <strong>cada etapa melhora o suporte ao editor</strong> e melhora sua base de código",
  index_2_adopt_blurb_2:
    "Vamos pegar esse código JavaScript incorreto e ver como o <strong>TypeScript pode detectar erros em seu editor</strong>.",

  index_2_migrate_1: "Arquivo JavaScript",
  index_2_migrate_2: "JavaScript com TS Check",
  index_2_migrate_3: "JavaScript com JSDoc",
  index_2_migrate_4: "Arquivo TypeScript",

  index_2_loved_by: "Amado por desenvolvedores",

  index_2_releases: "Lançamentos Trimestrais",
  index_2_releases_pt1: "Nosso próximo lançamento é ",
  index_2_releases_pt2: ", que está planejado para ",
  index_2_releases_released: "Lançados",
  index_2_releases_beta: "Beta",
  index_2_releases_rc: "RC",

  index_2_migration_title: "Historias de Migrações",
  index_2_migration_oss: "Código aberto com TypeScript",
  index_2_videos_title: "Veja o TypeScript em Ação",
}